<template>
    <!--eslint-disable-->
    <ValidationObserver v-slot="{ handleSubmit }" ref="form" id="edutalkCustomerForm">
        <form class="form customer-form" id="customer_create">
            <div class="row mb-3">
                <div class="col-md-4">
                    <div class="card card-custom gutter-b example example-compact border border-success mb-3"
                         v-if="filterOption?.basic.length > 0">
                        <div class="card-header bg-success">
                            <h3 class="card-title  text-white">Thông tin cơ bản</h3>
                        </div>

                        <!--begin::Form-->
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-label">Số điện thoại <span class="text-danger">*</span></label>
                                            <input type="number" disabled class="form-control"
                                                   v-model="customer.phone"
                                                   placeholder="Số điện thoại"
                                                   :disabled="check_edit"
                                            >
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">Họ tên <span class="text-danger">*</span></label>
                                            <input type="text" disabled class="form-control" placeholder="Họ tên"
                                                   v-model="customer.name">
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">Email</label>
                                        <input type="email" class="form-control" placeholder="Email"
                                               v-model="customer.email"
                                               :disabled="check_edit"
                                        >
                                    </div>
                                </div>
                                <div class="col-md-6" >
                                    <div class="form-group">
                                        <label class="form-label">Facebook<span class="text-danger"></span></label>
                                        <input type="text" disabled class="form-control" placeholder="Facebook" v-model="customer.link_fb">
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">Ngày sinh <span class="text-danger"> *</span></label>
                                            <el-date-picker
                                                disabled
                                                value-format="yyyy-MM-dd"
                                                class="customer-birthday"
                                                v-model="customer.ngay_sinh"
                                                placeholder="Ngày sinh"
                                            >
                                            </el-date-picker>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-label">Quê quán<span class="text-danger"></span></label>
                                        <input type="text" disabled class="form-control" placeholder="Quê quán" v-model="customer.que_quan">
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">Địa chỉ<span class="text-danger"></span></label>
                                        <input type="text" disabled class="form-control" placeholder="Địa chỉ" v-model="customer.address">
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-label">Trường học
                                        </label>
                                            <input
                                                disabled
                                                type="text"
                                                class="form-control"
                                                placeholder="Trường học"
                                                :value="customer?.truong_hoc?.name"
                                            >
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">Ngành học<span class="text-danger"></span></label>
                                        <input type="text" disabled class="form-control" placeholder="Ngành học" v-model="customer.nganh">
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3">
                                    <div class="form-group mb-1">
                                        <label class="form-label">Đối tượng<span class="text-danger"> *</span></label>
                                            <el-select v-model="customer.object_customer" disabled clearable class="w-100" placeholder="Chọn đối tượng">
                                                <el-option
                                                    v-for="item in objectCustomerDefine"
                                                    :key="item.id"
                                                    :label="item.value"
                                                    :value="item.id">
                                                    <span style="float: left">{{ item.value }}</span>
                                                </el-option>
                                            </el-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--end::Form-->
                    </div>
                    <div class="card card-custom gutter-b example example-compact border border-warning mt-4">
                        <div class="card-header bg-warning">
                            <h3 class="card-title text-white">Thông tin phụ huynh</h3>
                        </div>
                        <!--begin::Form-->
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">Họ tên<span class="text-danger"></span></label>
                                        <input type="text" disabled class="form-control" v-model="customer.bo_me" placeholder="Họ tên">
                                    </div>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">Số điện thoại</label>
                                        <input type="number" disabled class="form-control" v-model="customer.sdt_phu_huynh"
                                               placeholder="Số điện thoại">
                                    </div>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">Quê quán<span class="text-danger"></span></label>
                                        <input type="text" disabled class="form-control" placeholder="Quê quán"
                                               v-model="customer.que_quan_phu_huynh">
                                    </div>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">Nghề nghiệp<span class="text-danger"></span></label>
                                        <input type="text" disabled class="form-control" placeholder="Nghề nghiệp"
                                               v-model="customer.nghe_nghiep_phu_huynh">
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="form-label">Ý kiến<span class="text-danger"></span></label>
                                        <el-select disabled v-model="customer.y_kien_phu_huynh" clearable class="w-100" placeholder="Chọn ý kiến">
                                            <el-option
                                                v-for="item in yKien"
                                                :key="item.id"
                                                :label="item.value"
                                                :value="item.id">
                                                <span style="float: left">{{ item.value }}</span>
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--end::Form-->
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="card card-custom gutter-b example example-compact border border-primary">
                        <div class="card-header bg-primary">
                            <h3 class="card-title text-white">Thông tin khách hàng tiềm năng
                            </h3>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">Kênh<span class="text-danger"> *</span></label>
                                            <el-select  v-if="!check_re_register" disabled v-model="customer.nguon" clearable class="w-100" placeholder="Chọn kênh">
                                                <el-option
                                                    v-for="item in nguon"
                                                    :key="item.id"
                                                    :label="item.value"
                                                    :value="item.id">
                                                    <span style="float: left">{{ item.value }}</span>
                                                </el-option>
                                            </el-select>
                                            <el-input v-else disabled value="Tái đăng ký"></el-input>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3">
                                    <div class="form-group mb-1">
                                        <label class="form-label">Phím nóng <span class="text-danger">*</span></label>
                                            <el-select disabled v-model="customer.hot_key" clearable class="w-100" placeholder="Chọn phím nóng" multiple collapse-tags>
                                                <el-option
                                                    v-for="item in phimNongDeFine"
                                                    :key="item.id"
                                                    :label="item.value"
                                                    :value="item.id">
                                                    <span style="float: left">{{ item.value }}</span>
                                                </el-option>
                                            </el-select>
                                    </div>
                                </div>

                                <div class="col-md-12 mb-3" v-for="id in customer.hot_key" :key="id">
                                    <div class="form-group mb-1">
                                        <label class="form-label">Chi tiết: {{ getHotKeyLabel(id) }} <span class="text-danger"> *</span></label>
                                        <div
                                            v-if="!customer.hot_key_detail[id]"
                                            class="position-absolute text-muted px-2"
                                            style="pointer-events: none; top: 30px; left: 12px; white-space: pre-line; line-height: 1.8;">
                                            {{ getHotKeyPlaceholder(id) }}
                                        </div>
                                        <textarea
                                            disabled
                                            class="form-control"
                                            rows="5"
                                            v-model="customer.hot_key_detail[id]"
                                        ></textarea>
                                    </div>
                                </div>

                                <div class="col-md-12 mb-3">
                                    <div class="form-group mb-1">
                                        <label class="form-label">Giải pháp mời hẹn</label>
                                        <textarea disabled class="form-control" rows="3" v-model="customer.giai_phap_moi_hen"
                                                  placeholder="Giải pháp mời hẹn của cấp trên"></textarea>
                                    </div>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <div class="form-group mb-1">
                                        <label class="form-label">Ghi chú</label>
                                        <textarea disabled class="form-control" rows="3" placeholder="Ghi chú" v-model="customer.note"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="card card-custom gutter-b example example-compact border border-info mb-3">
                        <div class="card-header bg-info">
                            <h3 class="card-title text-white">Kết quả tư vấn</h3>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">Kết quả</label>
                                        <input v-if="customer.ket_qua_tu_van == '1'" disabled type="text" class="form-control is-valid"
                                               placeholder="Họ tên" value="Khách hàng đã đăng ký">
                                        <input v-else-if="customer.ket_qua_tu_van == '0'" disabled type="text"
                                               class="form-control is-invalid" placeholder="Họ tên" value="Khách hàng không đăng ký">
                                        <input v-else disabled type="text" class="form-control is-invalid" placeholder="Họ tên"
                                               value="Khách hàng chưa được tư vấn">
                                    </div>
                                </div>
                                <div class="col-md-12 mb-3" v-if="customer.ket_qua_tu_van == '1'">
                                    <div class="form-group">
                                        <label class="form-label">Khóa học muốn đăng ký</label>
                                        <input disabled type="text" class="form-control" placeholder="Lý do"
                                               v-model="customer.khoa_hoc_muon_dang_ky">
                                    </div>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">Lý do</label>
                                        <input disabled type="text" class="form-control" placeholder="Lý do"
                                               v-model="customer.nguyen_nhan_khong_dang_ky">
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">Tư vấn viên</label>
                                        <input disabled type="text" class="form-control" placeholder="Tư vấn viên"
                                               v-model="customer.tu_van_vien">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-label">SĐT tư vấn viên</label>
                                        <input disabled type="text" class="form-control" placeholder="SĐT tư vấn viên"
                                               v-model="customer.sdt_tvv">
                                    </div>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">Điểm test</label>
                                        <input disabled type="text" class="form-control" placeholder="Điểm test"
                                               v-model="customer.diem_test">
                                    </div>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">Nhận xét</label>
                                        <input disabled type="text" class="form-control" placeholder="Nhận xét"
                                               v-model="customer.nhan_xet_dau_vao">
                                    </div>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">Phím nóng bổ sung</label>
                                        <textarea class="form-control" rows="3" disabled v-model="customer.phim_nong_bo_sung"></textarea>
                                    </div>
                                </div>

                                <div class="col-md-6 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">Tài chính bổ sung {{typeof customer.dieu_kien_tai_chinh_bo_sung}}</label>
                                        <money  v-bind="money" class="form-control"
                                                disabled
                                                v-model="customer.dieu_kien_tai_chinh_bo_sung"></money>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-label">Người ra quyết định</label>
                                        <el-select v-model="customer.nguoi_ra_quyet_dinh_bo_sung" clearable class="w-100"
                                                   placeholder="Người ra quyết định" disabled>
                                            <el-option
                                                disabled
                                                v-for="item in nguoi_ra_quyet_dinh"
                                                :key="item.id"
                                                :label="item.value"
                                                :value="item.id">
                                                <span style="float: left">{{ item.value }}</span>
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="form-label">Vấn đề khách hàng sau tư vấn
                                            <span class="text-danger"></span></label>
                                        <textarea class="form-control" rows="3" disabled
                                                  v-model="customer.khach_hang_van_dang_con_van_de"
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                            <div v-if="filterOption.result.includes('list_contract')">
                                <hr style="margin-top: 20px;">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h4 class="form-group form-label">DANH SÁCH HỢP ĐỒNG</h4>
                                    </div>
                                </div>
                                <div v-if="customer && customer?.list_contract?.length">
                                    <div class="row" v-for="item in customer.list_contract" style="margin-top: 10px;">
                                        <div class="col-md-12">
                                            <a disabled style="font-size: 14px; color: #7453a6; text-decoration: underline !important; cursor: pointer; margin-top: 15px;" @click="handleViewContract(item)" >
                                                Hợp đồng {{ customer.user.name }} - {{ item.created_at_format }}</a>
                                        </div>
                                    </div>
                                </div>
                                <div v-else style="font-style: italic; margin-top: 5px;">
                                    <span>Chưa có hợp đồng!</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <el-dialog :title="dialog.title" class="responsive" :visible.sync="dialogFormVisible">
            <el-row :gutter="10" class="pr-2 pl-2">
                <contract-form
                    v-if="dialogFormVisible"
                    :customer-id="customer.id"
                    :center-id="contract.center_id"
                    :branch-id="contract.branch_id"
                    :contract="contract"
                    :check-edit="checkEdit"
                    :check-view="checkView"
                    @close="dialogFormVisible=false">
                </contract-form>
            </el-row>
        </el-dialog>
    </ValidationObserver>
</template>
<script>
import {Money} from 'v-money'
import FilterForm from "@/views/pages/customer/components/FiterFormCreateCustomer.vue";

import {
    CUSTOMER_FIND,
    CUSTOMER_FIND_RE_REGISTER
} from "@/core/services/store/customer/customer.module";

import {mapGetters, mapState} from "vuex";
import ContractForm from "@/views/pages/customer/contract-form";
import DatLichTuVan from "@/views/pages/customer/dat-lich-tu-van";

import RescheduleTestInput from "@/views/pages/customer/reschedule-test-input.vue";
import LoadingCreateTestInput from "@/views/pages/customer/components/LoadingCreateTestInput.vue";
import SuccesCreateInput from "@/views/pages/customer/components/SuccesCreateInput.vue";
import CancelCreateInput from "@/views/pages/customer/components/CancelCreateInput.vue";
import OverloadCreateTestInput from "@/views/pages/customer/components/OverloadCreateTestInput.vue";
import OptionCreateTestInput from "@/views/pages/customer/components/OptionCreateTestInput.vue";
import {
    STATUS_CREATE,
    STATUS_FAlURE,
    STATUS_OVER_LOADING,
    STATUS_PENDING,
    STATUS_TO_DO
} from "@/core/config/testInput/testInputOption";

const _ = require('lodash');
export default {
    components: {
        Money,
        ContractForm,
        FilterForm,
        DatLichTuVan,
        OptionCreateTestInput,
        OverloadCreateTestInput,
        CancelCreateInput,
        SuccesCreateInput,
        LoadingCreateTestInput,
        RescheduleTestInput,
    },
    name: "CustomerForm",
    data() {
        return {
            customer: {
                list_contract: [],
                ngay_sinh:'',
                phim_nong: '',
                hot_key_detail: {}
            },
            is_show_room: false,
            check_loading: false,
            check_loading_destroy: false,
            check_edit: false,
            trangThaiTuVan: [
                {
                    id: '',
                    value: "--Chọn--"
                },
                {
                    id: 0,
                    value: "Khách hàng không đăng ký"
                },
                {
                    id: 1,
                    value: "Khách hàng đã đăng ký"
                },

            ],
            centers: [],
            yKien: [
                {id: '', value: "(Chọn ý kiến)"},
                {id: 'Chưa hỏi', value: 'Chưa hỏi'},
                {id: 'Đã hỏi - Không đồng ý', value: 'Đã hỏi - Không đồng ý'},
                {id: 'Đã hỏi - Đồng ý', value: 'Đã hỏi - Đồng ý'}
            ],
            nguon: [
                {id: '', value: "--Chọn--"},
                {id: 'Nhân', value: 'Nhân'},
                {id: 'Nội bộ', value: 'Nội bộ'},
                {id: 'Ấm nóng', value: 'Ấm nóng'},
                {id: 'Tiếp xúc lạnh', value: 'Tiếp xúc lạnh'},
                // {id: 'Tái đăng ký', value: 'Tái đăng ký'},
                {id: 'Liên kết trường', value: 'Liên kết trường'},
                {id: 'Lạnh', value: 'Lạnh'},
                {id: 'Facebook ads', value: 'Facebook ads'},
                {id: 'Google ads', value: 'Google ads'},
                {id: 'Tiktok ads', value: 'Tiktok ads'},
                {id: 'Vệ tinh', value: 'Vệ tinh'},
            ],
            nguoi_ra_quyet_dinh: [
                {id: '', value: "--Chọn--"},
                {id: 'Phụ huynh', value: "Phụ huynh"},
                {id: 'Bạn bè', value: "Bạn bè"},
                {id: 'Bản thân', value: "Bản thân"},
            ],
            trangThaiHen: [
                {id: 0, value: "Chưa có lịch hẹn"},
                {id: 1, value: "Có lịch hẹn"},
                {id: 2, value: "Delay hẹn"},
                {id: 3, value: "Hủy hẹn"},
                {id: 4, value: "Hủy data"},
            ],

            // Cache
            cacheLevel: [],
            cacheNguon: [],
            cacheYkien: [],
            cacheTrangThaiHen: [],
            cacheTrangThaiTuVan: [],
            customer_id : 0,
            cacheTrungTamHen: [],
            cacheNguoiRaQuyetDinh: [],
            money: {
                decimal: ',',
                thousands: ',',
                prefix: '',
                suffix: ' VNĐ',
                precision: 0,
                masked: false,
            },
            checkDestroy: false,
            dialogFormVisible: false,
            dialogScheduleAdvice: false,
            submitHotKeyDetail: false,
            appointment: {
                center_id: ''
            },
            dialog: {
                title: ''
            },
            phimNongDeFine: [
                {id: 1, value: "Tài chính", placeholder: "- Ai người quyết định chi trả tài chính?\n- Mức tài chính có phù hợp với gia đình không?\n- Mức tài chính có thể chi trả là bao nhiêu?"},
                {id: 2, value: "Phương pháp học", placeholder: "- Khách hàng lo ngại về hiệu quả phương pháp học?\n- Khách hàng cần thêm thông tin về phương pháp học?\n- Tại sao phải học tiếng anh?\n- Tại sao phải học tiếng Anh ở trung tâm này thay vì trung tâm khác?"},
                {id: 3, value: "Gia đình/Mối quan hệ", placeholder: "- Ai là người quyết định mua hàng?\n- Ai là người tác động, có tầm ảnh hưởng trong gia đình?\n- Khách hàng tin tưởng ai? (bạn bè, anh, chị, bố mẹ...)\n- Ý kiến phụ huynh?"},
                {id: 4, value: "Thời gian", placeholder: "- Khách hàng vướng lịch chưa học được? (VD: quân sự, chờ thi xong học, nghỉ hè...)\n- Tại sao phải học tiếng anh tại thời điểm này?"},
                {id: 5, value: "Định hướng học IELTS", placeholder: "- Khách hàng học IELTS để ra trường?\n- Khách hàng học IELTS để xin việc?\n- Kế hoạch ngắn hạn? dài hạn?"},
                {id: 6, value: "Quyết định và lựa chọn", placeholder: "- Khách hàng còn phân vân giữa các lựa chọn?\n- Tại sao chưa quyết định, cần thêm thuyết phục về điều gì?"},
                {id: 7, value: "Khoảng cách", placeholder: "- Khách hàng ở xa trung tâm? ...km?\n- Khách hàng lo lắng về vấn đề đi lại"},
                {id: 8, value: "Nỗi sợ", placeholder: "- Khách hàng không học được?\n- Sợ chi phí học cao?\n- Phân vân giữa học chứng chỉ/ngôn ngữ?"},
                {id: 9, value: "Khác", placeholder: "- Sở thích, Tính cách, Thói quen, Mong muốn"},
            ],
            objectCustomerDefine: [
                {id: 1, value: "Học sinh"},
                {id: 2, value: "Sinh viên"},
                {id: 3, value: "Người đi làm"},
            ],
            contract: null,
            checkEdit: true,
            checkView: false,
            isScheduleAdvice: false,
            check_re_register : false,
            check_clear : false,
            isReRegister : {
                completeDeblt : false,
                contract30days : false
            },
            filterOption: {
                basic: ['name','phone','email','facebook','birthday','que_quan','address','school','major', 'object_customer'],
                parent: ['name','phone','origin','job','opinion'],
                potential: [
                    'source','hotkey','solution','note'
                ],
                result: [
                    'result','course_register','reason','consultant',
                    'consultant_phone','score','comment','hotkey_extra',
                    'financial_extra','decision_extra','problem','list_contract'
                ],
            },
            tableColumnsOption: {},
            testInput: null,
            idTaskCreating : null,
            STATUS_TO_DO:STATUS_TO_DO,
            STATUS_PENDING:STATUS_PENDING,
            STATUS_FAlURE:STATUS_FAlURE,
            STATUS_OVER_LOADING:STATUS_OVER_LOADING,
            STATUS_CREATE:STATUS_CREATE,
            countTime : 60,
            successCreateData:{},
            idConfig: 0
        }
    },

    async mounted() {
        if (this.errors) {
            this.$refs.form.setErrors(this.errors);
        }
        if (this.$route.params.id !== undefined) {
            this.check_edit = true;
            this.fetchCustomer();
        }
    },

    computed: {
        ...mapState({
            errors: state => state.auth.errors
        }),
        ...mapGetters(['currentUser', 'isPilot']),
    },
    methods: {
        fetchCustomer() {
            this.$store.dispatch(CUSTOMER_FIND, this.$route.query.customer_id).then((res) => {
                this.customer = res.data;
                this.customer.hot_key = (() => {
                    try {
                        return JSON.parse(this.customer.hot_key || '[]')
                    } catch {
                        return []
                    }
                })();

                this.customer.hot_key_detail = (() => {
                    try {
                        return JSON.parse(this.customer.hot_key_detail || '{}')
                    } catch {
                        return {}
                    }
                })();

                this.customer.ngay_sinh = (this.customer.ngay_sinh == '0000-00-00' || !this.customer.ngay_sinh) ?  '':  this.customer.ngay_sinh
                if (parseInt(res.data.level) < 3) {
                    this.checkDestroy = true;
                } else {
                    this.checkDestroy = false;
                }
            });
        },

        handleViewContract(contract) {
            this.dialog.title = 'Chi tiết hợp đồng';
            this.dialogFormVisible = true;
            this.checkEdit = false;
            this.checkView = true;
            this.contract = contract;
        },
        closeDialog() {
            this.dialog = false;
        },

        getHotKeyLabel(id) {
            const item = this.phimNongDeFine.find(i => i.id === id);
            return item ? item.value : '';
        },

        getHotKeyPlaceholder(id) {
            const item = this.phimNongDeFine.find(i => i.id === id);
            return item ? item.placeholder : '';
        }
    },
}
</script>
<style>
#edutalkCustomerForm .mx-datepicker {
    width: 100% !important;
}

#edutalkCustomerForm .card-header {
    color: #C9F7F5 !important;
}

#edutalkCustomerForm .el-dialog__body {
    padding: 2px 20px;
}
</style>
